import cameraSvg from "../../images/camera.svg"

const PhotoSlot = () => {
  return (
    <div sx={{ flex: 1 }}>
      <div
        sx={{
          display: "block",
          position: "relative",
          pb: 160,
          border: "1px",
          borderColor: "lightGrey",
          borderRadius: "8px",
        }}
      >
        <img
          src={cameraSvg}
          alt=""
          loading="lazy"
          sx={{
            position: "absolute",
            width: 32,
            height: "auto",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>
    </div>
  )
}

export default PhotoSlot
